import type { MessageQuote } from '../../types/chat';
import { truncateQuoteText } from '../../types/chat';

interface MessageQuoteBlockProps {
  quote: MessageQuote;
  isOutgoing?: boolean;
  onClick?: () => void;
}

export default function MessageQuoteBlock({
  quote,
  isOutgoing = false,
  onClick,
}: MessageQuoteBlockProps) {
  return (
    <button
      type="button"
      className={`message-quote ${isOutgoing ? 'outgoing' : 'incoming'}`}
      onClick={onClick}
      title="Voir le message cité"
    >
      <span className="message-quote-author">{quote.author}</span>
      <span className="message-quote-text">{truncateQuoteText(quote.text)}</span>
    </button>
  );
}
